//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import ConfiguracaoWorkflowAprovacao from './ConfiguracaoWorkflowAprovacao';
import ConfiguracaoCalendarioAprovacao from './ConfiguracaoCalendarioAprovacao';
import ConfiguracaoWorkflowContrato from './ConfiguracaoWorkflowContrato';
import ConfiguracaoOrcamento from './ConfiguracaoOrcamento';
import ConfiguracaoApuracaoAcordo from './ConfiguracaoApuracaoAcordo';
import ConfiguracaoPagamento from './ConfiguracaoPagamento';
import ConfiguracaoCadastro from './ConfiguracaoCadastro';
import ConfiguracaoNotificacaoEmail from './ConfiguracaoNotificacaoEmail';
import configuracaoResource from '../../common/resources/configuracao/configuracao';

export default {
  name: 'Configuracao',
  data() {
    return {
      configuracaoResources: configuracaoResource(this.$resource),
    };
  },
  computed: {
    ...mapGetters('roles', [
      'getAllRoles',
    ]),
    canAccessPage() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter(el => el.startsWith('CONFIG')).length;
    },
    canAccessPageOrcamento() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter(el => el === 'CONFIG_ORC').length;
    },
    canAccessPageCalendario() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter(el => el === 'CONFIG_CALENDARIO').length;
    },
    canAccessPageWorkflowAprovacao() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter(el => el === 'CONFIG_FLUXO').length;
    },
    canAccessPageWorkflowContrato() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter(el => el === 'CONFIG_NEG').length;
    },
    canAccessPageApuracaoAcordo() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter(el => el === 'CONFIG_APURACAO').length;
    },
    canAccessPagePagamento() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter(el => el === 'CONFIG_PGTO').length;
    },
    canAccessPageCadastro() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter(el => el === 'CONFIG_CADASTRO').length;
    },
    canAccessPageNotificacaoEmail() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
         .filter(el => el === 'CONFIG_EMAIL').length;
    },
  },
  components: {
    ConfiguracaoWorkflowAprovacao,
    ConfiguracaoCalendarioAprovacao,
    ConfiguracaoWorkflowContrato,
    ConfiguracaoOrcamento,
    ConfiguracaoApuracaoAcordo,
    ConfiguracaoPagamento,
    ConfiguracaoCadastro,
    ConfiguracaoNotificacaoEmail,
  },
  methods: {
    accessForbidden() {
      if (!this.canAccessPage) {
        this.$router.push({ name: 'inicio' });
        this.$toast.create('Acesso negado', 'snack', 3E3);
      }
    },
  },
  mounted() {
    if (!this.canAccessPage) {
      window.setTimeout(() => this.accessForbidden(), 1E3);
    }
  },
};



// WEBPACK FOOTER //
// ./src/spa/configuracao/Configuracao.vue?vue&type=script&lang=js&